import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

interface ISidebarContext {
  isMobile: boolean;
  mobileOpen: boolean;
  drawerOpen: boolean;
  showToolbar: boolean;
  handleDrawerToggle: () => void;
}

const SidebarContext = createContext<ISidebarContext | undefined>(undefined);

interface ISidebarProviderProps {
  children: React.ReactNode;
}

export const SidebarProvider: React.FC<ISidebarProviderProps> = ({
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);

  useEffect(() => {
    if (isMobile) {
      setDrawerOpen(false);
    } else {
      setDrawerOpen(true);
    }
  }, [isMobile]);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setDrawerOpen(!drawerOpen);
    }
  };

  const showToolbar = isMobile;

  const value = {
    isMobile,
    mobileOpen,
    drawerOpen,
    showToolbar,
    handleDrawerToggle,
  };

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
